import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import WarningIcon from "@icons/myicons/warning-triangle.svg?react";
import ClockIcon from "@icons/myicons/clock-time-arrow.svg?react";
import { formatDateDDMMYYYY } from "@helpers";
import { isExpired, isExpiringSoon } from "./helpers";

type Props = {
  expiresAt?: string;
  compact?: boolean;
};

export const TokenExpiryCell = ({ expiresAt, compact = false }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const expired = isExpired(expiresAt);

  const label = expired
    ? t("settings.apiAccess.table.expired", {
        date: formatDateDDMMYYYY(expiresAt),
      })
    : expiresAt
      ? [
          compact && t("settings.apiAccess.table.expires"),
          formatDateDDMMYYYY(expiresAt),
        ]
          .filter(Boolean)
          .join(" ")
      : t("settings.apiAccess.table.noExpiry");
  const iconSize = compact ? 14 : 20;

  return (
    <Box display="flex" alignItems="center" gap={compact ? 1 : 2}>
      {expired && (
        <ClockIcon
          width={iconSize}
          height={iconSize}
          color={theme.palette.error.main}
        />
      )}
      {!expired && isExpiringSoon(expiresAt) && (
        <WarningIcon
          width={iconSize}
          height={iconSize}
          color={theme.palette.warning.main}
        />
      )}
      <Typography
        variant={compact ? "caption" : "body3"}
        noWrap={compact}
        color={expired ? "error.main" : "textPrimary"}
      >
        {label}
      </Typography>
    </Box>
  );
};
